import {
  USERS_LIST,
  PREVIEW_USER,
  RESET_USERS_LIST,
  USERS_LIST_LOADING,
  SEARCH_FILTERS,
  SEARCH_FILTER_PANEL_TOGGLE,
  SEARCH_CAS,
  SEARCH_INSTITUTIONS,
  SEARCH_ORGANIZATION,
  SEARCH_STATUSES,
  SEARCH_USERROLES,
  PILLSBUGS_ACTION,
  PILLSBUGS_SET_ITEM_STATE,
  PILLSBUGS_RESET,
  USER_LOGOUT,
  USERS_RESET,
  PREVIEW_USER_RESET,
  ORAGNIZATION_LIST_BY_CLIENT_ID,
  ASSOCIATION_SPECIALTY,
  SUPER_USER_SPECIALITY,
  ASSOCIATION_SPECIALTY_LIST,
} from '../../actionTypes/Users/UserActionType';
import Constants from '../../Constants';

// this must contain initial (empty) userList object (by api response)
const getUsersListDefault = () => ({
  pageNumber: 0,
  pageSize: Constants.userListDefaultPageSize,
  totalElements: 0,
  name: '',
  type: '',
  contents: [],
  firstPage: false,
  hasContents: false,
  hasNextPage: false,
  hasPreviousPage: false,
  lastPage: false,
  numberOfElements: 0,
  searchTime: 0,
  totalPages: 0,
  totalUsers: 0,
  terms: {
    search: '',
    clientId: [],
    casId: [],
    institutionId: [],
    userRoleId: [],
    status: [],
    internalUser: [],
  },
  userSearchFilters: {
    search: '',
    institutionId: [],
    clientId: [],
    casId: [],
    userRoleId: [],
    status: [],
    internalUser: [],
  },
});

const getInitialUsersListState = () => ({
  loadingList: false,
  usersList: getUsersListDefault(),
  previewUser: null,
  filterPanelOpen: false,
  usersPills: {
    CAS: false,
    Institution: false,
    Organization: false,
    Role: false,
    Status: false,
    Internal: false,
  },
  filterOptions: {
    // the following props are not involved yet
    orgs: [], // filter as clientId []
    cas: [],
    institutions: [],
    userRoles: [],
    statuses: [],
    // active one
    internalUser: [
      {
        id: 'true',
        name: 'Internal Users',
      },
    ],
  },
});

export default function usersListReducer(state = { ...getInitialUsersListState() }, action) {
  switch (action.type) {
    case USERS_RESET:
      return { ...state, ...getInitialUsersListState() };
    case PREVIEW_USER_RESET:
      return { ...state, previewUser: { ...getInitialUsersListState().previewUser } };
    case USERS_LIST:
      return { ...state, loadingList: false, usersList: { ...state.usersList, ...(action.usersList || {}) } };
    case PREVIEW_USER:
      return { ...state, previewUser: { ...state.previewUser, ...(action.payload || {}) } };
    case USERS_LIST_LOADING:
      return { ...state, loadingList: true };
    case RESET_USERS_LIST:
      return { ...state, loadingList: false, usersList: getUsersListDefault() };
    case SEARCH_FILTERS:
      return { ...state, filters: { ...state.filters, ...(action.filters || {}) } };
    case SEARCH_FILTER_PANEL_TOGGLE:
      return { ...state, filterPanelOpen: action.payload.filterPanelOpen };
    case SEARCH_CAS:
      return { ...state, filterOptions: { ...state.filterOptions, cas: action.cas } };
    case SEARCH_INSTITUTIONS:
      return { ...state, filterOptions: { ...state.filterOptions, institutions: action.payload.institutions } };
    case SEARCH_ORGANIZATION:
      return { ...state, filterOptions: { ...state.filterOptions, orgs: action.orgs } };
    case SEARCH_STATUSES:
      return { ...state, filterOptions: { ...state.filterOptions, statuses: action.statuses } };
    case SEARCH_USERROLES:
      return { ...state, filterOptions: { ...state.filterOptions, userRoles: action.userRoles } };
    case PILLSBUGS_ACTION:
      return { ...state, usersPills: action.pillsBugs };
    case PILLSBUGS_SET_ITEM_STATE:
      return { ...state, usersPills: { ...state.usersPills, [action.payload.name]: !!action.payload.state } };
    case PILLSBUGS_RESET:
      return { ...state, usersPills: { ...getInitialUsersListState().usersPills } };
    case USER_LOGOUT:
      return { ...getInitialUsersListState(), usersList: getUsersListDefault() };
    case ORAGNIZATION_LIST_BY_CLIENT_ID:
      return { ...state, organisationListByClientId: action.payload?.organizationListByClientId || [] };
    case ASSOCIATION_SPECIALTY:
      return { ...state, associationSpecialty: action.payload?.associationSpecialty || [] };
    case ASSOCIATION_SPECIALTY_LIST:
      return { ...state, associationSpecialtyList: action.payload?.associationSpecialtyList || [] };
    case SUPER_USER_SPECIALITY:
      return { ...state, superUserSpeciality: action.payload?.superUserSpeciality || [] };
    default:
      return state;
  }
}
